import { InjectionToken } from '@angular/core';
import { ConnectivityReportsPort } from './connectivity-reports.port';

export const CONNECTIVITY_REPORTS_PORT = new InjectionToken<ConnectivityReportsPort>('CONNECTIVITY_REPORTS_PORT');